export const TrackingRepositoryFactory: ITrackingRepository = ({
  APIProvider,
  AuthService,
  APIRoutes,
}) => {
  const { POST } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  return {
    track: async (payload) => {
      return POST(APIRoutes.apiTracking, payload, {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
        keepAlive: true,
      } as unknown as HeadersInit);
    },
  };
};
